import React, { useState } from "react";
import { NavLink, Redirect } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import validator from "validator";
import "react-toastify/dist/ReactToastify.css";
import Input from "../../components/DataEntry/Input";
import Logo from "../../assets/images/boogie_logo.png";

interface IProps {}
// TODO Forgot password (One input field, button SEND)
const Login = (props: IProps) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    email: "",
    password: "",
  });

  const updateEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const updatePassword = (e: any) => {
    setPassword(e.target.value);
  };

  const validateFields = () => {
    var formValidated = true;
    var newValidationErrors = { email: "", password: "" };

    if (validator.isEmpty(email) || !validator.isEmail(email)) {
      newValidationErrors = {
        ...newValidationErrors,
        email: "Invalid email",
      };
      formValidated = false;
    }
    if (
      !validator.isStrongPassword(password, {
        minLength: 5,
        minNumbers: 0,
        returnScore: false,
        minLowercase: 0,
        minUppercase: 0,
        minSymbols: 0,
      })
    ) {
      newValidationErrors = {
        ...newValidationErrors,
        password: "Password too short",
      };
      formValidated = false;
    }
    setValidationErrors(newValidationErrors);
    return formValidated;
  };

  const submitLogin = async (e) => {
    if (validateFields()) {
      setLoading(true);
      try {
        const user = await login({ email, password });
        if (user?.token) {
          setLoading(false);
          setRedirect(true);
        }
      } catch (err) {
        setLoading(false);
        setError(true);
        toasti(err?.message || err);
      }
    }
  };

  const toasti = (errorMessage) => {
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div className="login">
      {redirect && <Redirect to="/loading" />}
      <div className="container">
        <img alt="logo" style={{ width: "70%" }} src={Logo} />
        <span className="title">Login</span>
        <Input
          placeholder="Email"
          className="input-classic"
          onChange={updateEmail}
          status={validationErrors.email && "error"}
          validationMessage={validationErrors.email}
          onPressEnter={submitLogin}
        />

        <Input
          placeholder="Password"
          className="input-classic"
          type="password"
          onChange={updatePassword}
          status={validationErrors?.password && "error"}
          validationMessage={validationErrors.password}
          onPressEnter={submitLogin}
        />
        {/* <div>
                    <div className="login--checkbox-container">
                        <label className="checkbox--label" htmlFor="remember">
                            <input className="checkbox" type="checkbox" value="remeber" id="remember" />
                            <span className="label-text">Remember me</span>
                        </label>
                        <NavLink className="link" to="/dashboard">Forgot password?</NavLink>
                    </div>
                </div> */}
        <button
          className={`button ${loading && "button--loading"}`}
          onClick={submitLogin}
          style={{ margin: "1rem auto 0" }}
        >
          {loading ? "" : "LOGIN"}
        </button>
        {/* {error && <p>Wrong credentials</p>} */}
        {error && (
          <ToastContainer
            autoClose={5000}
            position="bottom-right"
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        )}
        <div className="sign">
          {/* <NavLink className="sign-link" to="/forgot-password"> */}
          <NavLink className="sign-link" to="/forgot-password">
            Forgot password?
          </NavLink>
        </div>
        <div className="sign">
          Don&apos;t have an account?&nbsp;&nbsp;
          <NavLink to="/register" className="sign-link">
            Sign Up
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Login;
